module.exports = __webpack_public_path__ + "media/images/redesign-images/sorority/image-grid/grid-10-68dc0a4bb9c663cab319b685455597bf.jpg";